import { useCallback } from 'react';
import { Tag } from 'antd';
import { TRANSACTION_TYPE_COLORS, TRANSACTION_TYPE_ICONS } from '../constants';

export const useTransactionTypeRender = () => {
  return useCallback((type: string) => {
    if (!type) return '-';
    
    const color = TRANSACTION_TYPE_COLORS[type as keyof typeof TRANSACTION_TYPE_COLORS] || 'default';
    const icon = TRANSACTION_TYPE_ICONS[type as keyof typeof TRANSACTION_TYPE_ICONS] || null;
    const text = type === 'po' ? 'Purchase Order' : 'Sale';
    
    return (
      <Tag 
        color={color} 
        icon={icon}
        style={{ fontWeight: 500 }}
      >
        {text}
      </Tag>
    );
  }, []);
};